import { useSelector } from "react-redux";

import {
  DEFAULT_REPORT_RANGE_MONTHS,
  formatReportRangeLabel,
  isReportRangeMonths,
  REPORT_RANGE_LIMIT_KEY,
} from "src/constants/reportRange";

interface ReportRangeState {
  user?: {
    user?: {
      subscription?: { limits?: { REPORT_MODULE?: { [REPORT_RANGE_LIMIT_KEY]?: unknown } } } | null;
    } | null;
  };
}

export interface ReportRangeLimit {
  /** Months a report date range may span on the company plan. */
  months: number;
  /** `1 year`, `6 months`, ... */
  label: string;
}

/**
 * The company plan's report date range, from the profile (`subscription.limits.REPORT_MODULE.maxReportRangeMonths`).
 * A missing or unknown value is 1 year, the backend default.
 */
export const useReportRangeLimit = (): ReportRangeLimit => {
  const value = useSelector(
    (state: ReportRangeState) => state.user?.user?.subscription?.limits?.REPORT_MODULE?.[REPORT_RANGE_LIMIT_KEY],
  );
  const months = isReportRangeMonths(value) ? value : DEFAULT_REPORT_RANGE_MONTHS;

  return { months, label: formatReportRangeLabel(months) };
};
